/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay.clientUserNewOverlay{height:100%}.overlay.clientUserNewOverlay .ol-main{background:#f5f5f5}.overlay.clientUserNewOverlay .ol-main .ol-content{padding:0}.overlay.clientUserNewOverlay .ol-main .ol-content .content{padding-bottom:50px}"];
export { styles as styles };
